import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import styles from '../../styles/restpassword.module.css';
import axios from 'axios';
import loader from "../../images/load.gif"
import { toast } from 'react-toastify';
import Navbar from '../../components/Navbar';

function ResetPassword() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  const email = searchParams.get('email');
  const code = searchParams.get('code');

  const validate = () => {
    if (!confirmPassword || !password) {
      setError('Please fill in all fields');
      return false;
    }
    if (confirmPassword !== password) {
      setError('Passwords do not match');
      return false;
    }
    if (password.length < 6) {
      setError('Password must be at least 6 characters long');
      return false;
    }
    setError('');
    return true;
  };

  const resetPassword = async () => {
    const isValidated = validate();

    if (isValidated) {
      try {
        setLoading(true);

        const res = await axios.post('https://chatting-club-backend.onrender.com/api/users/reset-password', {
          password: password,
          code: code,
          email: email
        });

        if (res.data.success === true) {
          toast.success('🔐 Password reset successfully! You can now log in.', {
            position: 'bottom-right',
            theme: 'colored'
          });
          navigate('/login');
        } else {
          toast.error(res.data.message || 'Failed to reset password', {
            position: 'bottom-right',
            theme: 'colored'
          });
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        const errorMessage = error.response?.data?.message || 'Something went wrong. Please try again.';
        toast.error(errorMessage, {
          position: 'bottom-right',
          theme: 'colored'
        });
      }
    } else {
      toast.error(error, {
        position: 'bottom-right',
        theme: 'colored'
      });
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      resetPassword();
    }
  };

  useEffect(() => {
    if (!email || !code) {
      toast.error('Invalid reset link. Please request a new password reset.', {
        position: 'bottom-right',
        theme: 'colored'
      });
      navigate('/forgot-password');
    }
  }, [email, code, navigate]);

  return (
    <>
      <div className={styles.resetContainer}>
        <div className={styles.resetCard}>
          <div className={styles.iconWrapper}>
            <span className={styles.keyIcon}>🔑</span>
          </div>
          
          <h1 className={styles.resetTitle}>Create New Password</h1>
          <p className={styles.resetInstruction}>
            Enter your new password below to secure your account
          </p>
          
          <div className={styles.formGroup}>
            <label htmlFor="Password" className={styles.formLabel}>New Password</label>
            <div className={styles.passwordWrapper}>
              <input
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyPress={handleKeyPress}
                className={`${styles.formInput} ${error ? styles.inputError : ''}`}
                placeholder="Enter new password"
                type={showPassword ? 'text' : 'password'}
                id="Password"
                name="Password"
              />
              <button
                type="button"
                className={styles.passwordToggle}
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? 'Hide' : 'Show'}
              </button>
            </div>
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="Confirm_Password" className={styles.formLabel}>Confirm Password</label>
            <div className={styles.passwordWrapper}>
              <input
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                onKeyPress={handleKeyPress}
                className={`${styles.formInput} ${error ? styles.inputError : ''}`}
                placeholder="Confirm your password"
                type={showConfirmPassword ? 'text' : 'password'}
                id="Confirm_Password"
                name="Confirm_Password"
              />
              <button
                type="button"
                className={styles.passwordToggle}
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                {showConfirmPassword ? 'Hide' : 'Show'}
              </button>
            </div>
            {error && <p className={styles.errorMessage}>{error}</p>}
          </div>

          {password && password.length > 0 && (
            <div className={styles.passwordStrength}>
              <span className={
                password.length < 6 ? styles.weak : 
                password.length < 10 ? styles.medium : 
                styles.strong
              }>
                Password strength: {
                  password.length < 6 ? 'Weak' :
                  password.length < 10 ? 'Medium' :
                  'Strong'
                }
              </span>
              <div className={styles.strengthBar}>
                <div 
                  className={`${styles.strengthFill} ${
                    password.length < 6 ? styles.weak :
                    password.length < 10 ? styles.medium :
                    styles.strong
                  }`}
                  style={{ width: `${Math.min((password.length / 12) * 100, 100)}%` }}
                />
              </div>
            </div>
          )}

          {loading === true ? (
            <button className={`${styles.submitBtn} ${styles.loadingBtn}`} disabled>
              <img alt="loader" src={loader} width={30} height={30} />
              <span>Resetting...</span>
            </button>
          ) : (
            <button onClick={resetPassword} className={styles.submitBtn}>
              Reset Password
            </button>
          )}

          <div className={styles.backToLogin}>
            <span>Remember your password? </span>
            <button 
              className={styles.backLink} 
              onClick={() => navigate('/login')}
            >
              Back to Login
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default ResetPassword;